import React, { Component } from "react";
import { connect } from "react-redux";

import { withRouter } from "react-router-dom";
import OrderListLayout, {
  updateQueryStringInOrderList,
} from "../../../shared/order/order-list-layout";
import {
  OrderService,
  ProductService,
  PromotionalCicleService,
  TagService,
} from "../../../../services";
import { showErrorToast, showSuccessToast } from "../../../../components";
import { format } from "date-fns";
import AuthorService from "../../../../services/AuthorService";

class CompanyOrderListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      agentList: {
        loading: false,
        list: [],
      },
      authorList: {
        loading: false,
        list: [],
      },
      promotionalCicleList: {
        loading: false,
        list: [],
      },
      tagBusinessUnityList: {
        loading: false,
        list: [],
      },
      materialList: {
        loading: false,
        list: [],
      },
      productList: {
        loading: false,
        list: [],
      },
      orderList: {
        loading: false,
        list: [],
        total: 0,
      },
      numberPendingERP: 0,
      orderDetailData: {
        loading: false,
        data: {},
        total: 0,
      },
      orderOnApproval: {
        loading: false,
        finished: false,
      },
      orderOnMultipleApproval: {
        loading: false,
        finished: false,
        total: 0,
        approved: 0,
      },
    };
  }

  componentDidMount() {
    const buParams = {
      skip: 0,
      take: 7,
      type: 1,
    };

    this._requestTagBusinessUnityList(buParams);
  }

  _requestTagBusinessUnityList = async (data) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ tagBusinessUnityList }) => ({
        tagBusinessUnityList: {
          ...tagBusinessUnityList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await TagService.fetchTagList(data);

      this.setState(({ tagBusinessUnityList }) => ({
        tagBusinessUnityList: {
          ...tagBusinessUnityList,
          loading: false,
          list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ tagBusinessUnityList }) => ({
        tagBusinessUnityList: {
          ...tagBusinessUnityList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestOrderList = async (data) => {
    const { dispatch, history } = this.props;

    try {
      this.setState(({ orderOnMultipleApproval }) => ({
        orderOnMultipleApproval: {
          ...orderOnMultipleApproval,
          loading: false,
          finished: false,
          total: 0,
          approved: 0,
        },
      }));

      this.setState(({ orderList }) => ({
        loading: true,
        orderList: {
          ...orderList,
          loading: true,
        },
      }));

      updateQueryStringInOrderList(history, data);

      const {
        data: { list, total },
      } = await OrderService.fetchOrderList(data);

      this.setState(({ orderList }) => ({
        loading: false,
        orderList: {
          ...orderList,
          loading: false,
          list: [...list],
          total,
        },
      }));
    } catch (e) {
      this.setState(({ orderList }) => ({
        loading: false,
        orderList: {
          ...orderList,
          loading: false,
        },
      }));
      dispatch(showErrorToast(e.message));
    }
  };

  _requestOrderDetail = async (id) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ orderDetailData }) => ({
        loading: true,
        orderDetailData: {
          ...orderDetailData,
          loading: true,
          data: {},
        },
      }));

      const { data } = await OrderService.fetchOrderDetail(id);

      this.setState(({ orderDetailData }) => ({
        loading: false,
        orderDetailData: {
          ...orderDetailData,
          loading: false,
          data,
        },
      }));

      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: false,
        },
      }));
    } catch (e) {
      this.setState(({ orderDetailData }) => ({
        loading: false,
        orderDetailData: {
          ...orderDetailData,
          loading: false,
          data: {},
        },
      }));
      dispatch(showErrorToast(e.message));
    }
  };

  _requestAgentList = async (data) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ agentList }) => ({
        agentList: {
          ...agentList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await OrderService.fetchAgentList(data);

      this.setState(({ agentList }) => ({
        agentList: {
          ...agentList,
          loading: false,
          list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ agentList }) => ({
        agentList: {
          ...agentList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestAuthorList = async (data) => {
    const { dispatch } = this.props;
    try {
      this.setState(({ authorList }) => ({
        authorList: {
          ...authorList,
          loading: true,
        },
      }));

      const {
        data: { list },
      } = await OrderService.fetchAuthorList(data);

      this.setState(({ authorList }) => ({
        authorList: {
          ...authorList,
          loading: false,
          list,
        },
      }));
    } catch (e) {
      this.setState(({ authorList }) => ({
        authorList: {
          ...authorList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestPromotionalCicleList = async (data) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ promotionalCicleList }) => ({
        promotionalCicleList: {
          ...promotionalCicleList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await PromotionalCicleService.fetchPromotionalCicleList(data);

      this.setState(({ promotionalCicleList }) => ({
        promotionalCicleList: {
          ...promotionalCicleList,
          loading: false,
          list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ promotionalCicleList }) => ({
        promotionalCicleList: {
          ...promotionalCicleList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestMaterialList = async (data) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ materialList }) => ({
        materialList: {
          ...materialList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await OrderService.fetchMaterialList(data);

      this.setState(({ materialList }) => ({
        materialList: {
          ...materialList,
          loading: false,
          list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ materialList }) => ({
        materialList: {
          ...materialList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestProductList = async (data) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ productList }) => ({
        productList: {
          ...productList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await ProductService.fetchProductList(data);

      this.setState(({ productList }) => ({
        productList: {
          ...productList,
          loading: false,
          list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ productList }) => ({
        productList: {
          ...productList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _downloadSelectedData = async (orders) => {
    const { dispatch } = this.props;

    try {
      this.setState({
        loading: true,
      });

      await OrderService.downloadSelectedData(
        orders.map((order) => order.data.id),
        "export.csv"
      );

      dispatch(
        showSuccessToast(
          `${orders.length} Pedido${
            orders.length > 1 ? "s exportados" : " exportado"
          } com sucesso!`
        )
      );

      this.setState({
        loading: false,
      });
    } catch (e) {
      this.setState({
        loading: false,
      });

      dispatch(showErrorToast(e.message));
    }
  };

  _requestPendingERP = async () => {
    const { dispatch } = this.props;

    try {
      this.setState({
        loading: true,
      });

      const pendingERP = await OrderService.fetchFindAllPendingERP();

      this.setState({
        numberPendingERP: pendingERP.data,
        loading: false,
      });
    } catch (e) {
      this.setState({
        loading: false,
      });
      dispatch(showErrorToast(e.message));
    }
  };

  _downloadFilteredData = async (filters, search) => {
    const { dispatch } = this.props;

    try {
      this.setState({
        loading: true,
      });

      await OrderService.downloadFilteredData(
        filters,
        `export_${format(new Date(), "yyyy-MM-dd-HH-mm-ss")}.csv`,
        search
      );

      dispatch(showSuccessToast("Pedidos exportados com sucesso!"));

      this.setState({
        loading: false,
      });
    } catch (e) {
      this.setState({
        loading: false,
      });

      dispatch(showErrorToast(e.message));
    }
  };

  _requestApproveOrder = async (id) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: true,
          finished: false,
        },
      }));

      await OrderService.approveOrder(id);

      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: true,
        },
      }));
    } catch (e) {
      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestRefuseOrder = async (id) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: true,
          finished: false,
        },
      }));

      await OrderService.refuseOrder(id);

      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: true,
        },
      }));
    } catch (e) {
      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestMultipleApproveOrder = async (orders) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ orderOnMultipleApproval }) => ({
        orderOnMultipleApproval: {
          ...orderOnMultipleApproval,
          loading: true,
          finished: false,
        },
      }));

      const response = await OrderService.multipleApproveOrder(
        orders.map((orders) => orders.data.id)
      );

      this.setState(({ orderOnMultipleApproval }) => ({
        orderOnMultipleApproval: {
          ...orderOnMultipleApproval,
          loading: false,
          finished: true,
          total: response.data.approved.length + response.data.refused.length,
          approved: response.data.approved.length,
        },
      }));
    } catch (e) {
      this.setState(({ orderOnMultipleApproval }) => ({
        orderOnMultipleApproval: {
          ...orderOnMultipleApproval,
          loading: false,
          finished: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestCancelOrder = async (idOrIds, externalRequest) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: true,
          finished: false,
        },
      }));

      for (const orderId of idOrIds) {
        await OrderService.cancelOrder(orderId, externalRequest);
      }

      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: true,
        },
      }));
    } catch (e) {
      this.setState(({ orderOnApproval }) => ({
        orderOnApproval: {
          ...orderOnApproval,
          loading: false,
          finished: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _resetApprovalState = () => {
    this.setState(({ orderOnApproval }) => ({
      orderOnApproval: {
        ...orderOnApproval,
        finished: false,
      },
    }));
  };

  render() {
    const { userData } = this.props;

    const {
      loading,
      agentList,
      authorList,
      promotionalCicleList,
      materialList,
      productList,
      orderList,
      orderDetailData,
      orderOnApproval,
      orderOnMultipleApproval,
      tagBusinessUnityList,
      numberPendingERP,
    } = this.state;

    return (
      <OrderListLayout
        title="Pedidos"
        userData={userData}
        loading={loading}
        agentList={agentList}
        authorList={authorList}
        promotionalCicleList={promotionalCicleList}
        materialList={materialList}
        productList={productList}
        orderList={orderList}
        numberPendingERP={numberPendingERP}
        orderDetailData={orderDetailData}
        tagBusinessUnityList={tagBusinessUnityList}
        onRequestPendingERP={this._requestPendingERP}
        onRequestOrderDetail={this._requestOrderDetail}
        onRequestAgentList={this._requestAgentList}
        onRequestAuthorList={this._requestAuthorList}
        onRequestPromotionalCicleList={this._requestPromotionalCicleList}
        onRequestMaterialList={this._requestMaterialList}
        onRequestProductList={this._requestProductList}
        onRequestOrderList={this._requestOrderList}
        onExportFilteredData={this._downloadFilteredData}
        onExportSelectedData={this._downloadSelectedData}
        handleConfirmApproveDialog={this._requestApproveOrder}
        handleConfirmRefuseDialog={this._requestRefuseOrder}
        handleConfirmCancelDialog={this._requestCancelOrder}
        handleConfirmMultipleApproveDialog={this._requestMultipleApproveOrder}
        onResetApprovalState={this._resetApprovalState}
        loadingOrderDialog={orderOnApproval.loading}
        orderOnApprovalFinished={orderOnApproval.finished}
        loadingOrderOnMultipleApprovalDialog={orderOnMultipleApproval.loading}
        orderTotalOnMultipleApproval={orderOnMultipleApproval.total}
        orderOnMultipleApproval={orderOnMultipleApproval.approved}
        orderOnMultipleApprovalFinished={orderOnMultipleApproval.finished}
      />
    );
  }
}

const mapStateToProps = (data) => data;

export default connect(mapStateToProps)(withRouter(CompanyOrderListPage));
